<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table-list"></i>
        WFDetector(Web Forgery Detectior) Dashboard
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WFDetector</a>
        </li>
        <li class="separator">
          <i class="fa fa-angle-right"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Dashboard</a>
        </li>
      </ul>
    </div>
    <b-card>
      <!-- <template slot="header">
        <i class='fa fa-align-justify'></i> WFDetect(Web Forgery Detection) Dashboard
      </template> -->
        <b-row>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-primary">
              <b-card-body class="pb-0">
                <h1><strong>
                  <animated-number ref="module_check_1" :value="info.from && info.from.alive ? info.from.alive : 0" :formatValue="value_comma" :duration="1500"/>
                  <sup style="font-size: 20px"> 使用</sup></strong></h1>
                <hr>
                <h6>最近の情報</h6>
                <h4>アクティブ :
                  <animated-number ref="module_check_1" :value="info.from && info.from.alive ? info.from.alive : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>イナクティブ :
                  <animated-number ref="module_check_2" :value="info.from && info.from ? info.from.total - info.from.alive : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>トータル :
                  <animated-number ref="module_check_2" :value="info.from && info.from.total ? info.from.total : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-success">
              <b-card-body class="pb-0" >
                <h1><strong>
                  <animated-number ref="server_check_1" :value="info && info.server && info.server.alive > 0 ? info.server.alive : 0" :formatValue="value_comma" :duration="1500"/>
                  <sup style="font-size: 20px"> サーバ</sup></strong></h1>
                <hr>
                <h6>最近の情報</h6>
                <h4>有効 :
                  <animated-number ref="server_check_2" :value="info && info.server.alive && info.server.alive > 0 ? info.server.alive : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>無効 :
                  <animated-number ref="server_check_3" :value="info && info.server.deleted && info.server.deleted > 0 ? info.server.deleted : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>トータル :
                  <animated-number ref="server_check_4" :value="info && info.server.alive && info.server ? info.server.alive + info.server.deleted : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-info">
              <b-card-body class="pb-0">
                <h1><strong>
                  <animated-number ref="domain_check_1" :value="info && info.domain && info.domain.alive > 0 ? info.domain.alive : 0" :formatValue="value_comma" :duration="1500"/>
                <sup style="font-size: 20px"> ドメイン</sup></strong></h1>
                <hr>
                <h6>最近の情報</h6>
                <h4>有効 :
                  <animated-number ref="domain_check_2" :value="info && info.domain && info.domain.alive > 0 ? info.domain.alive : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>無効 :
                  <animated-number ref="domain_check_3" :value="info && info.domain && info.domain.deleted > 0 ? info.domain.deleted : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>トータル :
                  <animated-number ref="domain_check_4" :value="info && info.domain && info.domain.alive > 0 ? info.domain.alive + info.domain.deleted : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-danger">
              <b-card-body class="pb-0">
                <h1><strong>
                    <animated-number ref="detect_check_1" :value="info && info.detect && info.detect.day > 0 ? info.detect.day : 0" :formatValue="value_comma" :duration="1500"/>
                <sup style="font-size: 20px"> 検出</sup></strong></h1>
                <hr>
                <h6>最近の情報</h6>
                <h4>今日 :
                  <animated-number ref="detect_check_2" :value="info && info.detect && info.detect.day > 0 ? info.detect.day : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>直近7日間 :
                  <animated-number ref="detect_check_3" :value="info && info.detect && info.detect.week > 0 ? info.detect.week : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>今月 :
                  <animated-number ref="detect_check_4" :value="info && info.detect && info.detect.month > 0 ? info.detect.month : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
      <vcl-facebook v-if="loading"></vcl-facebook>
    <b-card ref="_ms" v-else>
      <b-row>
        <b-col class="title">
          エージェントの状況 (最大 100)
          <b-button class="float-right ml-2" size="m" variant='success' to="/downloads">新規サーバ</b-button>
          <b-button class="float-right ml-2" size="m" variant='success' to="/wmds/site">新規ドメイン</b-button>
        </b-col>
      </b-row>
      <hr>
      <b-row class="text-center">
        <agent-item v-for="(item, index) in agents" :key="index" :ref="`_agent_${index}`" :agent="item"></agent-item>
      </b-row>
      <b-row v-if="this.count == 0" style="text-align:center;">
        <b-col sm="6" lg="12">
          <b-card no-body class="bg-success">
            <b-card-body class="pb-20">
              <h3 class="mb-0">エージェントはインストールされていません</h3>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
    <router-view ></router-view>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
